import React from 'react';
import { Button } from '@/ui';

// Completed-state Generate Report block — surfaces the success message and
// CTA right below the inspection header so the inspector doesn't have to
// scroll past the section list to get to the next step. Lifted out of
// InspectionView.tsx during the 2026-05-01 split.

interface CompletedReportCtaProps {
  justCompleted: boolean;
  generatingReport: boolean;
  generateError: string | null;
  totalFindings: number;
  onGenerate: () => void;
}

export const CompletedReportCta: React.FC<CompletedReportCtaProps> = ({
  justCompleted,
  generatingReport,
  generateError,
  totalFindings,
  onGenerate,
}) => (
  <div className="space-y-3">
    {justCompleted && (
      <div className="p-4 bg-sev-maintenance-soft border border-sev-maintenance/30 rounded-xl flex items-start gap-3">
        <svg className="w-5 h-5 text-sev-maintenance shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div>
          <p className="text-body-sm font-semibold text-sev-maintenance-ink">Inspection complete!</p>
          <p className="text-caption text-sev-maintenance-ink/80 mt-0.5">
            Generate a draft report from your findings. You'll review everything and send it manually when ready.
          </p>
        </div>
      </div>
    )}
    <Button
      variant="primary"
      className="w-full"
      size="lg"
      loading={generatingReport}
      disabled={totalFindings === 0}
      onClick={onGenerate}
      leadingIcon={
        <svg fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      }
    >
      Generate Report
    </Button>
    {totalFindings === 0 && (
      <p className="text-caption text-center text-ink-faint">No findings to include in a report.</p>
    )}
    {generateError && (
      <p className="text-caption text-center text-sev-critical">{generateError}</p>
    )}
  </div>
);
